//签收

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 类型
 */
class Type extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "下游采购商-供应商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "下游采购商-联合采购商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合采购商-供应商");
}

export const TYPE = new Type();

/**
 * 签收状态
 */
class State extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    CONFIRMING = new Meta(2, "确认中");
    REJECTED = new Meta(3, "已驳回");
    FINISHED = new Meta(4, "已完成");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}

export const STATE = new State();

/**
 * 结算状态
 */
class ReconciliationState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    WAIT_CONFIRM = new Meta(2, "待确认");
    CONFIRMING = new Meta(3, "确认中");
    SIGNING = new Meta(4, "签署中");
    FINISHED = new Meta(5, "已完成");
    REJECTED = new Meta(6, "已驳回");
}

export const RECONCILIATION_STATE = new ReconciliationState();

class QueryType extends UltMeta {
    RECEIVER_CUSTOMER = new Meta(1, "签收方");
    SUPPLIER_CUSTOMER = new Meta(2, "供货方");
}

export const QUERY_TYPE = new QueryType();
